import axios from "axios";
export var portalUrlApi = axios.create({
    baseURL: process.env.PORTAL_URL,
});
